import { MARQUEE_WORDS } from "@/data";

export const Marquee = () => {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section data-testid="marquee-section" className="bg-cream py-14 md:py-20 overflow-hidden border-y border-charcoal/10">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="stroke-text font-serif text-[13vw] md:text-[9vw] leading-none px-8">
              {w}
            </span>
            <span className="text-terracotta font-serif text-[6vw] md:text-[4vw] leading-none">
              &bull;
            </span>
          </span>
        ))}
      </div>
    </section>
  );
};
